import React from "react";

export default function BannerCard({
    banner,
    onClick

}) {
    console.log(banner);
    return (
        <button
            className="banner-card"
            onClick={onClick}
        >
            <img
                src={banner}
                alt={banner}
            />
        </button>
    );

}